import BaseApi from './base';
import store from '@/store';
import { ActionType } from '@/constants';
import { getImpersonationParams } from '@/util';

const reset = (email: string, confirmationCode: string, password: string) => BaseApi.postStream('buyer/resetPassword', {
  email,
  confirmationCode,
  password
}, {
  headers: { clientid: process.env.VUE_APP_CLIENT_ID }
});

const validateResetPasswordCode = (email: string, confirmationCode: string) => BaseApi.postStream('buyer/validateResetPasswordCode', {
  email,
  confirmationCode
}, {
  headers: { clientid: process.env.VUE_APP_CLIENT_ID }
});

const getUserData = (): Promise<any> => new Promise((resolve, reject) => {
  BaseApi.get('buyer/details', { params: getImpersonationParams() }).then(response => {
    if (response.user) {
      store.dispatch(ActionType.UPDATE_USER_DATA, response.user).then(data => {
        resolve(response.user);
      });
    }
  })
});

const getJobBadges = (divisionId: string, jobId: string, resetVal = 0) => BaseApi.get(`buyer/getBadgesCount/${resetVal}/${divisionId}/${jobId}`, { params: getImpersonationParams() }).then(response => {
  if (response) {
    store.dispatch(ActionType.UPDATE_JOB_BADGES, response).then(_ => {
      return response;
    });
  }
});

const getLoginAttributes = (email: string) => BaseApi.get(`loginAttempts/${email}`, {});

const logErrorInfo = (errorDetails: any) => BaseApi.post('logError', errorDetails, {});

const validateAdmin = (token: string, email: string) => BaseApi.get(`authenticateAdminToken/${token}/${email}`, {});

const removeCoBuyerFromHome = (jobId: string) => BaseApi.delete(`buyer/removeFromJob/${jobId}`, {});

export {
  reset, validateResetPasswordCode, getUserData, getJobBadges, getLoginAttributes, logErrorInfo, validateAdmin, removeCoBuyerFromHome
}
